// Client layer (TS-2.5.03) - presentation only. Renders the five roadmap.web stat cards
// (RoadmapView.counts.cards, PortfolioCounts.cards: StatCardValue[]) per BRD section 8.2 and
// decomposition.md section 8.7 point 5 - which output profile produced them, how many cards and
// what each counts, is entirely server decided; this component only lays out and colours
// whatever it is handed.
//
// D-284: each card can now be OPENED (owner requirement - "showing the number on top may keep
// people guessing") to see the projects the server counted (`StatCardValue.memberProjectKeys`,
// D-283). That per-card interactivity/modal-state is StatCard.tsx's job, not this component's -
// StatCards stays the pure layout/ordering component it always was, handing each card its own
// slice plus the `projectsByKey` map a card's modal needs to resolve keys to projects. The map is
// the SAME one both callers (RoadmapPage, FrozenRoadmapPanel) already build from `view.cards` for
// the board itself, so this component fetches nothing new and works identically in every grouping
// mode (the cards are grouping-independent) and on a frozen/archived view - a snapshot predating
// D-283 upgrades to an EMPTY `memberProjectKeys` per card (decisions.md D-283's stored-shape
// upgrade), which this component's own empty-card rule already renders as non-interactive, so the
// frozen view degrades honestly with no extra code here.
import { resolveColor } from "./lib/colorTokens";
import { StatCard } from "./StatCard";
import type { ProjectView, StatCardValue } from "../../api/generated/contracts";
import { strings } from "../../strings";

export interface StatCardsProps {
  readonly cards: readonly StatCardValue[];
  readonly projectsByKey?: ReadonlyMap<string, ProjectView>;
}

const EMPTY_PROJECTS_BY_KEY: ReadonlyMap<string, ProjectView> = new Map();

export function StatCards({ cards, projectsByKey = EMPTY_PROJECTS_BY_KEY }: StatCardsProps) {
  const ordered = [...cards].sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <ul className="eg-stat-cards" aria-label={strings.roadmap.aria.summary}>
      {ordered.map((card) => (
        <li key={card.label} className="eg-stat-card" style={{ borderColor: resolveColor(card.colorToken) }}>
          <StatCard card={card} projectsByKey={projectsByKey} />
        </li>
      ))}
    </ul>
  );
}
